module.exports = __webpack_public_path__ + "static/media/2.1164a803.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Urolift/Images/2.png
// module id = 645
// module chunks = 0